/* ============================================================
   FROG SPOILER — Bologna 2026
   Reveal mechanic + publisher filter + countdown
   ============================================================ */
(function () {
  'use strict';

  const root = document.getElementById('frog-spoiler');
  if (!root) return;

  const STORAGE_KEY = 'frog-spoiler:revealed';

  // -----------------------------------------------------------
  // localStorage helpers — guarded for Safari private mode etc.
  // -----------------------------------------------------------
  function readRevealed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return new Set();
      const arr = JSON.parse(raw);
      return new Set(Array.isArray(arr) ? arr : []);
    } catch (_) {
      return new Set();
    }
  }

  function writeRevealed(set) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(set)));
    } catch (_) {
      /* quota / private mode — silently ignore */
    }
  }

  // -----------------------------------------------------------
  // Reveal mechanic
  // -----------------------------------------------------------
  function initReveals() {
    const revealed = readRevealed();
    const dossiers = root.querySelectorAll('[data-fs-dossier]');

    dossiers.forEach((dossier) => {
      const handle = dossier.getAttribute('data-fs-handle');
      const btn = dossier.querySelector('[data-fs-redact]');
      if (!btn) return;

      // restore previously revealed state
      if (handle && revealed.has(handle)) {
        btn.classList.add('is-revealed');
        btn.setAttribute('aria-expanded', 'true');
      }

      btn.addEventListener('click', function () {
        const isOpen = btn.classList.toggle('is-revealed');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (handle) {
          const set = readRevealed();
          if (isOpen) set.add(handle);
          else set.delete(handle);
          writeRevealed(set);
        }
      });
    });
  }

  // -----------------------------------------------------------
  // Publisher filter
  // -----------------------------------------------------------
  function initFilter() {
    const stamps = root.querySelectorAll('[data-fs-publisher]');
    const dossiers = root.querySelectorAll('[data-fs-dossier]');
    if (!stamps.length || !dossiers.length) return;

    stamps.forEach((stamp) => {
      stamp.addEventListener('click', function () {
        const target = stamp.getAttribute('data-fs-publisher');

        stamps.forEach((s) => {
          const active = s === stamp;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        dossiers.forEach((d) => {
          const vendor = d.getAttribute('data-fs-vendor') || '';
          const visible = target === '*' || vendor === target;
          d.classList.toggle('is-hidden', !visible);
        });
      });
    });
  }

  // -----------------------------------------------------------
  // Countdown
  // -----------------------------------------------------------
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initCountdown() {
    const wrap = root.querySelector('[data-fs-countdown]');
    if (!wrap) return;

    const targetISO = root.getAttribute('data-event-target');
    if (!targetISO) return;

    const target = new Date(targetISO).getTime();
    if (isNaN(target)) return;

    const dEl = wrap.querySelector('[data-fs-cd-d]');
    const hEl = wrap.querySelector('[data-fs-cd-h]');
    const mEl = wrap.querySelector('[data-fs-cd-m]');
    const sEl = wrap.querySelector('[data-fs-cd-s]');
    const labelEl = wrap.querySelector('.frog-spoiler__countdown-label');

    function tick() {
      const now = Date.now();
      const diff = target - now;

      if (diff <= 0) {
        if (labelEl) labelEl.textContent = 'L\'evento è iniziato';
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        return false;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const mins = Math.floor((diff / (1000 * 60)) % 60);
      const secs = Math.floor((diff / 1000) % 60);

      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
      return true;
    }

    if (tick()) {
      const interval = setInterval(function () {
        if (!tick()) clearInterval(interval);
      }, 1000);
    }
  }

  // -----------------------------------------------------------
  // Boot
  // -----------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveals();
      initFilter();
      initCountdown();
    });
  } else {
    initReveals();
    initFilter();
    initCountdown();
  }
})();
